import Vue from 'vue'
import { dpaPermissions } from 'src/directives/directive-dpa-permissions.js'

Vue.directive('dpa-permissions', dpaPermissions)
